import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router'
import classNames from 'classnames';
import { Field } from 'redux-form';
import {
  Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem, InputWarehouse
} from 'react-bootstrap';
import { Translate, Localize,I18n } from 'react-redux-i18n';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import TextareaField from '../Common/TextareaField';
import { SelectionWithProps } from '../Common/selection';
import checkPermission from '../Common/permissions';
import { isGGI, isCCW, isGFD } from '../../actions/root_url';
//import {buttonStyle, marginTopStyle, centerStyle} from '../Common/style'

const Checkbox = props => {
  return (
    <div>
      <label style={{ marginRight: '10px' }}><Translate value="invoice_select_batch" />:  </label>
      <input
        {...props.input}
        type="checkbox"
        value={!props.input.value ? "true" : "false"}
        checked={props.input.value === true || props.input.value === "true"}
        disabled={props.disabled}
      />
      <Translate value="yes" />
    </div>
  );
}

class WarehouseForm extends Component {
  // static contextTypes = {
  //   router: React.PropTypes.object
  // };
  //
  // constructor() {
  //   super();
  //   this.state = {
  //     dirty: false
  //   };
  // }

  // componentDidMount() {
  //   // making a leaving hook to confirm leaving
  //   this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  //   if (this.props.currentWarehouse) this.props.fetchWarehouseDetail(this.props.currentWarehouse);
  // }
  
  handleFormSubmit = _.debounce((formProps) => {
    this.setState({ dirty: false });
    if (formProps && formProps.id) {
      this.props.editWarehouse(formProps);
    }
    else {
      this.props.createWarehouse(formProps);
    }
  }, 500);

  isDisable(){
    // let {currentWarehouse} = this.props;
    // if (currentWarehouse && currentWarehouse.id) {
    //     return true;
    // } else {
    //     return false;
    // }
    return false;
  }

  // componentWillReceiveProps(nextProps) {
  //     if (nextProps.dirty != this.props.dirty) {
  //         this.setState({
  //             dirty: nextProps.dirty
  //         });
  //     }
  // }

  // routerWillLeave(nextLocation) {
  //     if (this.state.dirty) return <Translate value="work_not_saved_warning" />
  // }

  // title() {
  //     if (this.props.currentWarehouse) return <Translate value="warehouse_detail_view" />| <Translate value="edit_warehouse" />;
  //     else return <Translate value="warehouse_detail_view" /> | <Translate value="create_warehouse" />;
  // }

  renderForm() {
    if (isGGI) return;
    return (
      <Row>
        <Col sm={ 2 } />
        <Col sm={ 4 }>
          <Row><Col sm={ 12 }><label><Translate value="company_name" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Company_id" disabled={true} component={ SelectionWithProps } options={this.props.companySelection} /></Col></Row>
          <Row><Col sm={ 12 }><label><Translate value="warehouse_name" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Name" component={ InputField } /></Col></Row>
          <Row>
            <Col sm={ 6 }><label><Translate value="warehouse_code" /> (*) </label></Col>
            <Col sm={ 6 }><label><Translate value="is_public" /> (*) </label></Col>
          </Row>
          <Row><Col sm={ 6 }><Field name="warehouse_num" component={ InputField } disabled={this.isDisable()}/></Col><Col sm={ 6 }><Field name="is_public" component={ SelectionWithProps } options={[{ label: <Translate value="yes" />, value: true}, { label: <Translate value="no" />, value: false }]}/></Col></Row>
          <Row><Col sm={ 12 }><label><Translate value="address" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Street" component={ InputField } placeholder={I18n.t("street")}/></Col></Row>
          <Row><Col sm={ 12 }><Field name="City" component={ InputField } placeholder={I18n.t("city")}/></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="State" component={ InputField } placeholder={I18n.t("state")}/></Col>
            <Col sm={ 6 }><Field name="Zip" component={ InputField } placeholder={I18n.t("zip")}/></Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="contact_person" /></label></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="FirstName" component={ InputField } placeholder={I18n.t("first_name")}/></Col>
            <Col sm={ 6 }><Field name="LastName" component={ InputField } placeholder={I18n.t("last_name")}/></Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="email" /></label></Col></Row>
          <Row>
            <Col sm={ 12 }><Field name="Email" component={ InputField } placeholder="example@abc.com"/></Col>
          </Row>
          <Row>
            <Col sm={ 6 }>
              <Row><Col sm={ 12 }><label><Translate value="phone" /></label></Col></Row>
              <Row>
                <Col sm={ 12 }><Field name="Telephone" component={ InputField } placeholder="123-456-7890"/></Col>
              </Row>
            </Col>
            <Col sm={ 6 }>
              <Row><Col sm={ 12 }><label><Translate value="mobile" /></label></Col></Row>
              <Row>
                <Col sm={ 12 }><Field name="Cellphone" component={ InputField } placeholder="123-456-7890"/></Col>
              </Row>
            </Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="fax" /></label></Col></Row>
          <Row>
            <Col sm={ 12 }><Field name="Fax" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
          {
            isCCW &&
            <Row>
              <Col sm={ 12 }>
                <Field
                  name="invoice_select_batch"
                  component={Checkbox}
                />
              </Col>
            </Row>
          }
        </Col>
      </Row>
    )
  }

  renderGGIForm = () => {
    if (!isGGI) return;
    return (
      <Row>
        <Col sm={ 4 }>
          <Row><Col sm={ 12 }><label><Translate value="company_name" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Company_id" disabled={true} component={ SelectionWithProps } options={this.props.companySelection} /></Col></Row>
          <Row><Col sm={ 12 }><label><Translate value="warehouse_name" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Name" component={ InputField } /></Col></Row>
          <Row><Col sm={ 12 }><label><Translate value="chinese_name" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="description" component={ InputField } /></Col></Row>
          <Row>
            <Col sm={ 6 }><label><Translate value="warehouse_code" /> (*) </label></Col>
            <Col sm={ 6 }><label><Translate value="is_public" /> (*) </label></Col>
          </Row>
          <Row><Col sm={ 6 }><Field name="warehouse_num" component={ InputField } disabled={this.isDisable()}/></Col><Col sm={ 6 }><Field name="is_public" component={ SelectionWithProps } options={[{ label: 'yes', value: true}, { label: 'no', value: false }]}/></Col></Row>
          <Row><Col sm={ 12 }><label><Translate value="address" /> (*) </label></Col></Row>
          <Row><Col sm={ 12 }><Field name="Street" component={ InputField } placeholder="Street"/></Col></Row>
          <Row><Col sm={ 12 }><Field name="City" component={ InputField } placeholder="City"/></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="State" component={ InputField } placeholder="State"/></Col>
            <Col sm={ 6 }><Field name="Zip" component={ InputField } placeholder="Zip"/></Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="phone" /></label></Col></Row>
          <Row>
            {/* <Col sm={ 12 }><Field name="manager_telephone" component={ InputField } placeholder="123-456-7890"/></Col> */}
            <Col sm={ 12 }><Field name="Cellphone" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="fax" /></label></Col></Row>
          <Row>
            <Col sm={ 12 }><Field name="Fax" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
          <Row><Col sm={ 12 }><label><Translate value="remarks" /></label></Col></Row>
          <Row>
            <Col sm={ 12 }><Field name="Remarks" component={ TextareaField } /></Col>
          </Row>
        </Col>
        
        <Col sm={4}>
          <Row><Col sm={ 12 }><h4><Translate value="Reciving/Service" /></h4></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="FirstName" component={ InputField } placeholder="First Name"/></Col>
            <Col sm={ 6 }><Field name="LastName" component={ InputField } placeholder="LastName"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="Email" component={ TextareaField } placeholder="example@abc.com"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="Telephone" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
          <br />
          <Row><Col sm={ 12 }><h4><Translate value="Shipping/Release/Transfer/Appointment" /></h4></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="shipping_first_name" component={ InputField } placeholder="First Name"/></Col>
            <Col sm={ 6 }><Field name="shipping_last_name" component={ InputField } placeholder="LastName"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="shipping_email" component={ TextareaField } placeholder="example@abc.com"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="shipping_telephone" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
          <br />
          <Row><Col sm={ 12 }><h4><Translate value="Manager" /></h4></Col></Row>
          <Row>
            <Col sm={ 6 }><Field name="manager_first_name" component={ InputField } placeholder="First Name"/></Col>
            <Col sm={ 6 }><Field name="manager_last_name" component={ InputField } placeholder="LastName"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="manager_email" component={ TextareaField } placeholder="example@abc.com"/></Col>
          </Row>
          <Row>
            <Col sm={ 12 }><Field name="manager_telephone" component={ InputField } placeholder="123-456-7890"/></Col>
          </Row>
        </Col>
      </Row>
    )
  }

  render() {
    const { handleSubmit, closeG, submitting, pristine, valid, isCreating } = this.props;
    return (
      <ContentWrapper>
        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this)) } style={{ overflowY: 'auto' }}>
          <br/>
          <div className="pull-right">
              { (isCreating || this.props.isEditing) && <Spinner/> }
              { this.props.createError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.createError)}</div> }
              { this.props.editError && <div className="alert alert-danger marginTopStyle" >{JSON.stringify(this.props.editError)}</div> }

              <button action="submit" className="btn btn-primary buttonStyle" disabled={ isCreating || pristine || !valid || !checkPermission("change_warehouse") } ><Translate value="save" /></button>
              <button className="btn btn-danger buttonStyle" onClick={(event) => { event.preventDefault(); closeG(); } } ><Translate value="cancel" /></button>

            {
              isGFD &&
              <Row style={{ marginTop: '10px', marginRight: '15px' }}>
                <Col sm={ 12 }>
                  <label><Translate value="inventory_count_method" /> (*) </label>
                  <Field name="inventory_count_method" component={ SelectionWithProps } options={[{ label: 'mixed', value: 'mixed'}, { label: "unit", value: "unit" }, { label: "case", value: "case" }]} />
                </Col>
              </Row>
            }
          </div>
          { this.renderForm() }
          { this.renderGGIForm() }
        </form>
      </ContentWrapper>
    )
  }
}

const mapState = (state) => {
  return {
    companySelection: state.header.companies.map(({ Name, id }) => ({
      label: Name,
      value: id,
    }))
  }
}
export default connect(mapState, {})(withRouter(WarehouseForm));



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/warehouseForm.jsx